<script lang="ts">
  import { CtaEntity } from "@shared/services/event_tracking/entities";
  import Skeleton from "svelte-skeleton/Skeleton.svelte";
  import TrackingContext from "@shared/svelte/Components/Tracking/TrackingContext.svelte";
  import UIRouterLink from "@shared/svelte/Components/UIRouterLink.svelte";
  import DistributorCatalogDistributorContext from "@retailer/svelte/ProductLines/OrderActionBar/Cards/DistributorCatalogDistributorContext.svelte";

  import type { Distributor } from "@shared/types/Distributor";

  export let isLoading = true;
  export let distributors: Distributor[];

  const trackingParams = new CtaEntity({ service: "action_bar_add_distributors" });
</script>

<div class="fizz-flow-8 fizz-inset-square-8">
  {#if isLoading}
    {#each Array(3) as _}
      <Skeleton animate={true} height={22} width={238} ariaLabel="mobile-distributor-loading" />
    {/each}
  {:else}
    {#each distributors as distributor, i (distributor.id)}
      <div class="fizz-flex-row fizz-badge fizz-justify-center">
        <DistributorCatalogDistributorContext {distributor}>
          <UIRouterLink
            classes="fizz-full-width"
            id="distributor_{distributor.id}_link"
            params={{ distributors: distributor.id }}
            stateName={"layout.product_listing"}
            targetObjectType="content_card"
            useTrackClick={true}
          >
            <p class="fizz-text-small" data-testId="sorted-distributor-{i}">
              {distributor.name}
            </p>
          </UIRouterLink>
        </DistributorCatalogDistributorContext>
      </div>
    {/each}
  {/if}
  <TrackingContext entities={trackingParams}>
    <UIRouterLink
      stateName="layout.accounts"
      classes="underline-hover cursor-pointer fizz-flex-row-8"
      useTrackClick={true}
      targetObjectType="content_card"
    >
      <p class="fizz-text-small fizz-text-strong fizz-text-left">+ Add more distributors</p>
    </UIRouterLink>
  </TrackingContext>
</div>
